__turbopack_context__.v({
  "button": "SubscribeButton-module__D_wosq__button",
});
